import { API_URL, API_VERSION } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useState } from 'react';

const ENDPOINT_URL = '/prd-product-variants/my-account/{uuid}';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type DeleteProductVariantInput = paths[url]['delete']['parameters']['path'];

/**
 * Requests endpoint to delete a product's variant.
 */
export const useDeleteProductVariant = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);

    const request = async (props: DeleteProductVariantInput) => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL.replace('{uuid}', props.uuid || '')}`, {
                method: 'DELETE',
                headers: getHeaders(),
                body: JSON.stringify(getCommonParameters()),
            });

            if (!response.ok) {
                let error;

                try {
                    const json = await response.json();
                    error = new Error(json.message || '') as ApiError;
                    error.statusCode = response.status;
                } catch (error: any) {
                    error = new Error() as ApiError;
                    error.statusCode = response.status;
                }
                
                throw error;
            }

            // NOTE:
            // if this service is called successfully,
            // there's no need to parse content, because it will return none (204 No Content)

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            handleCommonErrors(error);
            error.message && setError(error.message);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };
    
    return { request, loading, error, lastResponseTime };
};
